// removed by extract-text-webpack-plugin
module.exports = {"headFootPanel":"mUxdM4O3vi2qV21WK3t-B"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeadFootPanel/HeadFootPanel.scss
// module id = 819
// module chunks = 0